import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
// import { Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Clear from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
// import { Collapse, Menu } from "@material-ui/core";
//import TextField from "@mui/material/TextField";
import Calendar from "react-calendar";
import {
  Collapse,
  Menu,
  ListItemIcon,
  ListItemText,
  InputAdornment,
} from "@mui/material";
// import { ListItemIcon, ListItemText } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Components from "..";
import { patientActions, doctorActions, zoomActions } from "../../core/actions";
import { helperServices } from "../../shared/helper";
import {
  FLOORNURSE,
  NURSE_ROLE,
  DOCTOR_ROLE,
  JOIN_Meeting_BUTTON_AVAILABLE_TIME_DIFF_HRS,
  LAB_ADMIN,
  RADIOLOGY,
  X_RAY,
  ROLE_KEYS,
  DIRECTOR_ROLE,
} from "../../shared/constants";
import { format } from "date-fns";
import { Loading } from "../erp-billing/Loading";
import ErrorScreen from "../../shared/helper/ErrorScreen";
import { Dialog, TextField, Button, Alert } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  getAllMasterLocationDetails,
  successDispatch,
} from "../erp-billing/ERPActions/erpActions";
import { ERP_HMS_MASTER_LOCATION_DETAILS } from "../../core/constants/erpConstants";
import { debounce } from "lodash";
import DoctorLeaveCalender from "../appointmentList/DoctorLeaveCalender";

function DoctorHomeView(props) {
  console.log("DoctorHomeView props:", props);
  const history = useHistory();
  const [selectedPatientInfo, setSelectedPatientInfo] = useState({});
  const [selectedPatient, setSelectedPatient] = useState({});
  const [selectedDatePres, setSelectedDatePres] = useState({});
  const [messageDetails, setMessageDetails] = useState({});
  const [renderPrescription, setRenderPrescription] = useState(false);
  const [myPatients, setMyPatients] = useState(true);
  const [showPatientBasic, setShowPatientBasic] = useState(false);
  const [options, setOptions] = useState(null);
  const [showPatientEditForm, setShowPatientEditForm] = useState(false);
  const [showPatientProcedure, setShowPatientProcedure] = useState(false);
  const [showPatientRevisitModal, setshowPatientRevisitModal] = useState(false);
  const [loggedUserRole, setLoggedUserRole] = useState(false);
  const [joinnow, setjoinnow] = useState(false);
  const [patientList, setPatientList] = useState({});
  const [doctorList, setDoctorList] = useState({});
  const [showReviewModel, setShowReviewModel] = useState(false);
  const [showjoinButton, setShowJoinButton] = useState(false);
  const [load, setLoad] = useState(true);
  const [selectddiv, setselectddiv] = useState();
  const [doctorDuty, setDoctorDuty] = useState(false);
  const [role, setRoles] = useState("");
  const dispatch = useDispatch();
  const [newPatientForAppointment, setNewPatientForAppointment] =
    useState(null);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [procedure, setProcedure] = useState({
    patientId: "",
    visitId: "",
    groupid: "",
  });
  const [logoutVisible, setLogoutVisible] = useState(false);
  const [openAddPatientModal, setOpenAddPatientModal] = useState(false);
  const [showPatientDetail, setshowPatientDetail] = useState(false);

  const [calenderModal, setCalenderModal] = useState(false);
  const [dateSelect, setDateSelect] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [userName, setUserName] = useState();
  const [sortPatientList, setSortPatientList] = useState();
  const [showVisits, setShowVisits] = useState();
  const [countIP, setIPcount] = useState();
  const [countOP, setOPcount] = useState();
  const [countWalkin, setWalkinCount] = useState();
  const [countAll, setAllcount] = useState();
  const [type, setType] = useState("All");
  const [addNewPatient, setAddNewPatient] = useState(false);
  const [calendar, setCalendar] = useState(false);
  const [doctorInfo, setDoctorInfo] = useState({});
  const [registrationfeesFlag, setRegistrationfeesFlag] = useState();
  const [qualification, setQualification] = useState();
  const [revisitDetail, setRevisitDetail] = useState({
    patientId: "",
    visitId: "",
    closecomment: "",
    closeScheduledTime: "",
    scheduleddate: "",
  });
  const [showCalendar, setShowCalendar] = useState(false);
  const [showFilterOption, setShowFilterOption] = useState(false);
  const [date, setDate] = useState(new Date());
  const [dataset, setDataset] = useState({});
  const [patientInfo, setPatientInfo] = useState({
    visitId: "",
    patientId: "",
    name: "",
    age: "",
    phno: "",
    id: "",
    address: "",
    adhar: "",
    age: "",
    area: "",
    visit: {
      reference: {
        refkey: "",
        refby: "",
      },
      referenceId: "",
    },
    bloodgroup: "",
    city: "",
    lname: "",
    mname: "",
    fname: "",
    fileNo: "",
    occupation: "",
    patientcode: "",
    pincode: "",
    type: "OutPatient",
  });

  const [paymentModal, setPaymentModal] = useState(false);
  const [isLabAdmin, setIsLabAdmin] = useState(
    JSON.parse(localStorage.getItem("role")) &&
      JSON.parse(localStorage.getItem("role")) === ROLE_KEYS.LabAdmin
      ? true
      : false,
  );
  const [isMedicalOffice, setIsMedicalOffice] = useState(
    JSON.parse(localStorage.getItem("role")) &&
      JSON.parse(localStorage.getItem("role")) === ROLE_KEYS.MedicalOfficer
      ? true
      : false,
  );

  const [isRadiology, setIsRadiology] = useState(
    JSON.parse(localStorage.getItem("role")) &&
      JSON.parse(localStorage.getItem("role")) === ROLE_KEYS.Ultrasound
      ? true
      : false,
  );

  const [isxRay, setIsxRay] = useState(
    JSON.parse(localStorage.getItem("role")) &&
      JSON.parse(localStorage.getItem("role")) === ROLE_KEYS.XRay
      ? true
      : false,
  );

  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const allPatientsList = useSelector(
    (state) => state.patientDetailsState.patientsList,
  );

  const optionList = [
    { label: "VisitDate", value: "VisitDate" },
    { label: "FollowupDate", value: "FollowupDate" },
  ];
  const [selectedOpt, setSelectedOpt] = useState("VisitDate");
  const [errorMessages, setErrorMessages] = useState("");
  const genderMap = {
    Male: "M",
    Female: "F",
  };

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [openPwdPopup, setOpenPwdPopup] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwdError, setPwdError] = useState("");
  const [pwdSuccess, setPwdSuccess] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [hideResults, setHideResults] = useState(false);

  // const doctorId = pat?.person?.personId;

  useEffect(() => {
    console.log("USERNAME: ", userName);
  }, [userName]);

  useEffect(() => {
    //  ERP Changes - Prathibha
    console.log("env: ", process.env.REACT_APP_ENV);
    let role = JSON.parse(localStorage.getItem("role"));
    console.log("role:", role);
    setRoles(role);
    // let name = helperServices.getLoggedUserName();
    let name = helperServices.getLoggedUserName();
    let displayTitile = "";
    let personData = "";
    if (role && role === ROLE_KEYS.LabAdmin) {
      setIsLabAdmin(true);
      renderVisitLists();
    }
    if (role && role === ROLE_KEYS.MedicalOfficer) {
      setIsMedicalOffice(true);
      renderVisitLists();
    }
    if (role && role === ROLE_KEYS.Ultrasound) {
      setIsRadiology(true);
      renderVisitLists();
    }
    if (role && role === ROLE_KEYS.XRay) {
      setIsxRay(true);
      renderVisitLists();
    }

    if (role === DOCTOR_ROLE || role === DIRECTOR_ROLE) {
      fetchMasterLocationDeatils();
      personData = JSON.parse(localStorage.getItem("doctorInformation"));
      setQualification(personData.qualification);
      console.log("DoctorInformation LocalStorage", personData);
      if (
        personData.type.toLowerCase() === "counsellor" ||
        personData.type.toLowerCase() === "doctor"
      ) {
        displayTitile = personData.displaytitle; // Set display title based on personData.type
      }
    }
    let formattedName =
      role === DOCTOR_ROLE || role === DIRECTOR_ROLE
        ? displayTitile + " " + helperServices.getFullName(name, null, null)
        : helperServices.getFullName(name, null, null);
    setUserName(formattedName);

    //To load the selected data on page refresh
    if (
      sessionStorage.getItem("visitDetailsBy") &&
      sessionStorage.getItem("visitDetailsBy") != null
    ) {
      console.log("im here ");
      let det = JSON.parse(sessionStorage.getItem("visitDetailsBy"));
      console.log("det:", det);
      listPatients(det);
    } else {
      fetchMasterLocationDeatils();
      console.log("doctor login");
      loadPatientListByRole();
    }
    fetchMasterLocationDeatils();
    getDoctorsList();
    let query = window.location.href;
  }, []);

  const fetchMasterLocationDeatils = async (patientVisitType) => {
    const masterLocationList = await getAllMasterLocationDetails();
    if (!masterLocationList) return;

    const masterLocList = [];

    const allLoc = {
      displayName: "All",
      locationKey: "all",
      locationDetails: {
        erpLocationDetails: [
          {
            address: "Mangalore",
            locationid: [],
            name: "All",
            prefix: "All",
          },
        ],
      },
      servicesAllowed: [],
    };
    console.log("location list in nurse login", masterLocList);

    masterLocationList.forEach((location) => {
      const currentUserRole = helperServices.getRole();
      const erpItem = location.locationDetails?.erpLocationDetails?.[0];

      // 🔹 OPTIONAL: role check (remove if not needed)
      // if (
      //   erpItem?.hmsRolesAllowed &&
      //   !erpItem.hmsRolesAllowed.includes(currentUserRole)
      // ) {
      //   return;
      // }

      // collect ids for ALL
      if (erpItem?.locationid) {
        allLoc.locationDetails.erpLocationDetails[0].locationid.push(
          erpItem.locationid,
        );
      }

      // collect services for ALL
      location.servicesAllowed?.forEach((service) => {
        if (!allLoc.servicesAllowed.includes(service)) {
          allLoc.servicesAllowed.push(service);
        }
      });

      masterLocList.push(location);
    });

    masterLocList.unshift(allLoc);
    dispatch(successDispatch(ERP_HMS_MASTER_LOCATION_DETAILS, masterLocList));
  };

  const getDoctorsList = (data) => {
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          let list = [];
          console.log("called person api");
          setLoader(false);
        }
      }),
    );
  };

  const renderVisitLists = () => {
    let data = {};
    console.log("text length is:");
    dispatch(
      patientActions.ListVisits(data, (resCb) => {
        if (resCb.patsearchreslt) {
          let allPatientsList;
          var doctorId = {};
          if (resCb?.personList) {
            console.log("resCb.personlist", resCb.patient);
            if (
              resCb &&
              resCb.personList &&
              resCb.personList != undefined &&
              resCb.personList.length != 0
            ) {
              doctorId.id = resCb.personList[0].personId;
              setDoctorInfo(doctorId);
            }
          }
          for (let pat of resCb.patsearchreslt) {
            pat["join"] = timecheck(
              pat.visit.apptdate,
              pat.visit.appthours,
              pat.visit.apptminutes,
            );
            pat.fullName = [pat.fname, pat.mname, pat.lname]
              .filter(Boolean)
              .join(" ");

            if (pat.person && pat.person.first_name) {
              console.log("fullName of doctor : ", pat.person);
              const str = pat.person.first_name;
              pat.person["fullName"] =
                pat.person.displaytitle + " " + pat.person.first_name;
            }
            console.log("patient listPatients pat FOR LOOP 356: ", pat);

            //sort patientlist by meeting join time and then by visitdate
            const trueOnly = resCb.patsearchreslt.filter((resCb) => resCb.join);
            const falseOnly = resCb.patsearchreslt.filter(
              (resCb) => resCb.join == false,
            );
            for (let eachItem of falseOnly) {
              pat["visitDate"] = eachItem.visit.visitDate;
            }
            falseOnly.sort(function (x, y) {
              return new Date(y.visitDate) - new Date(x.visitDate);
            });
            allPatientsList = trueOnly.concat(falseOnly);
            console.log("allSortedPatient", allPatientsList);
          }
          setCounts(allPatientsList);
          setSortPatientList(allPatientsList);
          setPatientList(allPatientsList);
        }
      }),
    );
  };

  const getDefaultVisitFilter = () => ({
    targetId: "",
    floorId: "",
    department: "",
    selectedOption: "All",
  });

  const applyVisitFilter = (filter) => {
    const resolvedFilter = filter || getDefaultVisitFilter();
    sessionStorage.setItem("visitDetailsBy", JSON.stringify(resolvedFilter));
    setDataset(resolvedFilter);
    if (resolvedFilter?.selectedOption) {
      setOptions(resolvedFilter.selectedOption);
    }
    listPatients(resolvedFilter);
  };

  const loadPatientListByRole = () => {
    let data = {
      targetId: null,
      floorId: null,
      department: null,
    };
    let name = helperServices.getLoggedUserName();
    let formattedName = helperServices.getFullName(name, null, null);
    console.log("role based login in user name : ", formattedName);
    let role = JSON.parse(localStorage.getItem("role"));
    let displayTitile = "";
    if (role === DOCTOR_ROLE || role === DIRECTOR_ROLE) {
      let personData = JSON.parse(localStorage.getItem("doctorInformation"));
      console.log("DoctorInformation LocalStorage", personData);
      if (
        personData.type.toLowerCase() === "counsellor" ||
        personData.type.toLowerCase() === "doctor"
      ) {
        displayTitile = personData.displaytitle; // Set display title based on personData.type
      }
      console.log("displayTitile", displayTitile);
      data.targetId = Number(localStorage.getItem("id"));
      formattedName = displayTitile + " " + formattedName;
      listPatients(data);
      console.log("listpatients data", data);
      setDataset(data);
    }
    setUserName(formattedName);

    setLoggedUserRole(role);
    console.log("Role: ", role);
    data["type"] = "mypatient";
    if (role == FLOORNURSE) {
      listFloors();
    } else if (role == NURSE_ROLE) {
      let det = null;
      try {
        const savedVisitDetails = sessionStorage.getItem("visitDetailsBy");
        det = savedVisitDetails ? JSON.parse(savedVisitDetails) : null;
      } catch (error) {
        console.error("Error parsing visitDetailsBy", error);
      }

      if (det && (det.targetId || det.floorId || det.department || det.selectedOption)) {
        applyVisitFilter(det);
      } else {
        applyVisitFilter(getDefaultVisitFilter());
      }
    } else {
      listPatients();
    }
  };

  const logout = (event) => {
    // helperServices.logout();
    localStorage.clear();
    sessionStorage.clear();
  };

  const selectVisit = (e) => {
    console.log("show visit details", e);
    setShowVisits(true);
    setLogoutVisible(!logoutVisible);
  };

  const logoutOpt = (e) => {
    setLogoutVisible(!logoutVisible);
  };

  const toggleUserActions = () => {
    setLogoutVisible(!logoutVisible);
  };

  const closeModal = (e) => {
    setShowVisits(false);
    console.log("event returned:", e);
    if (e) {
      applyVisitFilter(e);
    }
  };

  //ERP Changes - Prathibha
  const patientCloseClick = () => {
    console.log("props in patientclose: ", props);
    console.log("selectedpatientinfo: ", selectedPatientInfo);
    selectedPatientInfo.typeFlag = "patientClose";
    let patientId = selectedPatientInfo.id;
    let visitId = selectedPatientInfo.visit.id;
    dispatch(
      patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          console.log("resCbe : ", resCb);
          revisitDetail["scheduleddate"] = resCb.scheduleddate;
          revisitDetail.patientId = resCb.patientId;
          revisitDetail.visitId = resCb.visitId;
        }
      }),
    );
    setshowPatientRevisitModal(true);
  };
  //

  const dPatient = useSelector(
    (state) => state.patientDetailsState.ListPatients,
  );

  function getDifferenceInDays(date1, date2) {
    console.log("date1 : ", date1);
    console.log("date2 : ", date2);
    //  date2 =  (date2.getMonth()+1) + '/' + date2.getDate()  + '/' +  date2.getFullYear()
    console.log(
      "date2 : ",
      new Date(date2).getTime(),
      new Date(date1).getTime(),
    );
    console.log(
      "date2 hours: ",
      new Date(date1).getHours(),
      new Date().getHours(),
    );
    const diffInTime = new Date(date2).getTime() - new Date(date1).getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    // Calculating the no. of days between two dates
    const diffIndays = Math.round(diffInTime / oneDay);
    const diffInHours = new Date().getHours() - new Date(date1).getHours();
    console.log("Difference_In_Days :......... ", diffIndays, diffInHours);
    return diffInHours;
  }
  const timecheck = (date, hours, minutes) => {
    var diffInMonth = new Date(date).getMonth() - new Date().getMonth();
    var diffInYear = new Date(date).getFullYear() - new Date().getFullYear();
    if (diffInMonth == 0 && diffInYear == 0) {
      var diffIndays = new Date(date).getDate() - new Date().getDate();
      //const oneDay = 1000 * 60 * 60 * 24;
      //var diffIndays = Math.round(diffInTime / oneDay);
      var diffInHours = hours - new Date().getHours();
      var diffInMinutes = minutes - new Date().getMinutes();
      console.log("get hourse", new Date().getHours());
      console.log(" hourse", hours);
      console.log("get minutes", new Date().getMinutes());
      console.log("minutes", minutes);
      console.log(" Date", new Date(date).getDate());
      console.log(" Date", new Date(date).getMonth());
      console.log(" Date", new Date(date).getFullYear());
      console.log("diffIndays", diffIndays);
      console.log("diffIndays", diffInMonth);
      console.log("diffIndays", diffInYear);
      console.log("diffInHours", diffInHours);
      console.log("diffInMinutes", diffInMinutes);
      // var diffInSeconds = new Date(date).getSeconds() - new Date().getSeconds()
      if (diffIndays == 0) {
        if (
          diffInHours > -JOIN_Meeting_BUTTON_AVAILABLE_TIME_DIFF_HRS &&
          diffInHours < JOIN_Meeting_BUTTON_AVAILABLE_TIME_DIFF_HRS
        ) {
          console.log("inside diffInHours");
          //  if(diffInMinutes <= 0){
          //   console.log("min time ",diffInMinutes );
          //   console.log("diffInHours const: ",diffInHours , " :",JOIN_Meeting_BUTTON_AVAILABLE_TIME_DIFF_HRS )
          return true;
          // }
        } else {
          return false;
        }
      } else {
        return false;
      }
      return false;
    }
    return false;
  };

  // ERP Changes - Prathibha
  const onCloseVisitCompletion = (event) => {
    console.log("event:", event);
    patientCloseClick();
  };
  //

  const timeBetweenDates = (date1, date2) => {
    //console.log(getDifferenceInDays("2/1/2021", "3/1/2021"));
    console.log("getUTCDate :", new Date().toISOString());
    console.log(
      "date2 : ",
      new Date(date2).getTime(),
      new Date(date1).getTime(),
    );
    console.log(
      "date2 hours: ",
      new Date(date1).getHours(),
      new Date().getHours(),
    );
    const diffInTime = new Date(date2).getTime() - new Date(date1).getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    // Calculating the no. of days between two dates
    const diffIndays = Math.round(diffInTime / oneDay);
    const diffInHours = new Date().getHours() - new Date(date1).getHours();
    const diffInMinutes =
      new Date().getMinutes() - new Date(date1).getMinutes();
    const diffInSeconds =
      new Date().getSeconds() - new Date(date1).getSeconds();
    console.log("current : ", new Date(), new Date(date1));
    console.log("diffInHours", diffInHours, diffInMinutes, diffInSeconds);
    console.log("days : ", new Date().getHours(), new Date(date1).getHours());
    if (diffInHours > 12) {
      return new Date(date1).toDateString();
    } else {
      if (diffIndays >= 1) {
        return new Date(date1).toDateString();
      } else {
        if (diffInHours == 0 && diffInMinutes > 0) {
          return diffInMinutes + " minutes ago";
        }
        if (diffInHours == 0 && diffInMinutes == 0) {
          return diffInSeconds + " seconds ago";
        }
        return diffInHours + " hours ago";
      }
    }
  };

  const getPatientProcedureInfo = (patient, index) => {
    console.log("sorted list:", sortPatientList);
    props.history.push({
      pathname: `/patient`,
    });
    setAddNewPatient(false);
    console.log("event : ", patient);
    setselectddiv(patient.id);
    console.log("selected patient : ", selectddiv);
    // change the alignment in mobile-view
    if (document.getElementById("user-list"))
      document.getElementById("user-list").classList.add("mobile-view");
    if (document.getElementById("user-info"))
      document.getElementById("user-info").classList.add("mobile-view");
    let patientId = patient.id;
    let selectedPatient = {};
    setSelectedPatientInfo(patient);
    console.log("selected patient info", selectedPatientInfo);
    setSelectedPatient(patient);
    console.log("selected patient is", selectedPatient);
    setShowPatientProcedure(true);
    setShowPatientBasic(false);
    console.log("selected patient is--", selectedPatient);
    console.log("selected patient ipatient.id--", patient.id);
    dispatch(
      patientActions.getPatientProfile(patient.id, (resCb) => {
        if (resCb) {
          console.log(
            "getPatientProfile resp age phno and last visited:",
            resCb,
          );
          setErrorMessages(
            Array.isArray(resCb?.errorMessages) ? resCb.errorMessages[0] : "",
          );
          dispatch(patientActions.setPatientDetails(resCb));
          //   setSelectedPatientInfo(resCb)
        }
      }),
    );
  };

  const changeTab = (type) => {
    console.log("type:", type);
    setType(type);
    if (type != "All") {
      let filter = patientList.filter((item) =>
        type === "Walkin"
          ? (item.visit.visitflag || "").toLowerCase() === "walkin"
          : item.visit.type == type &&
            (type !== "InPatient" ||
              (item.visit.visitflag || "").toLowerCase() !== "walkin"),
      );
      setSortPatientList(filter);
    } else {
      setSortPatientList(patientList);
    }
  };

  const updatePatientDetails = (event, payment) => {
    console.log("patient added successfully:", event);
    if (event) {
      if (event.successMessages) {
        setMessageDetails({
          message: event.successMessages[0],
          success: "success",
        });

        setTimeout(() => {
          console.log("props:", props);
          let patientId;
          let visitId;
          if (event.patientresp.visit) {
            patientId = event.patientresp.visit.patientId;
            visitId = event.patientresp.visit.id;
          }

          let erpCustId = event.patientresp.erpCustId;
          let name = event.patientresp.fname;
          setSelectedPatientInfo(event.patientresp);

          if (payment === "payment") {
            if (JSON.parse(localStorage.getItem("role")) === LAB_ADMIN) {
              dispatch(
                patientActions.registrationFees(
                  erpCustId,
                  0,
                  visitId,
                  patientId,
                  "MNH",
                  [],
                  (resCb) => {
                    if (resCb && resCb.successMessages) {
                      console.log(
                        "resCb in registration fees in case of mnh : ",
                        resCb,
                      );

                      // **FIX 1: Close patient form first**
                      setAddNewPatient(false);
                      setOpenAddPatientModal(false);

                      // **FIX 2: Refresh patient list to get updated data**
                      renderVisitLists();

                      // **FIX 3: Wait for list to refresh, then get full patient data**
                      setTimeout(() => {
                        // Get fresh patient data from the list
                        dispatch(
                          patientActions.getPatientProfile(
                            patientId,
                            (patientResCb) => {
                              if (patientResCb) {
                                console.log(
                                  "Fresh patient data:",
                                  patientResCb,
                                );

                                // Get visit list to get visitAssignment details
                                dispatch(
                                  patientActions.getVisitListById(
                                    visitId,
                                    "showAllVisits",
                                    (visitResCb) => {
                                      if (
                                        visitResCb &&
                                        visitResCb.patsearchreslt &&
                                        visitResCb.patsearchreslt[0]
                                      ) {
                                        const fullPatientData =
                                          visitResCb.patsearchreslt[0];

                                        // **FIX 4: Ensure visitAssignment structure exists**
                                        if (!fullPatientData.visitAssignment) {
                                          fullPatientData.visitAssignment = {
                                            id: null,
                                            visitid: visitId,
                                            patientId: patientId,
                                            targetid: 0,
                                            status: "open",
                                            type: "Doctor",
                                          };
                                        }

                                        // Initialize visitAssignmentList if needed
                                        if (
                                          !Array.isArray(
                                            fullPatientData.visitAssignmentList,
                                          )
                                        ) {
                                          fullPatientData.visitAssignmentList =
                                            [];
                                        }

                                        // Add visitAssignment to list if not present
                                        if (
                                          fullPatientData.visitAssignment &&
                                          fullPatientData.visitAssignmentList
                                            .length === 0
                                        ) {
                                          fullPatientData.visitAssignmentList.push(
                                            fullPatientData.visitAssignment,
                                          );
                                        }

                                        console.log(
                                          "Complete patient data for appointment:",
                                          fullPatientData,
                                        );

                                        // **FIX 5: Now open appointment modal with complete data**
                                        setNewPatientForAppointment(
                                          fullPatientData,
                                        );
                                        setShowAppointmentModal(true);
                                      }
                                    },
                                  ),
                                );
                              }
                            },
                          ),
                        );
                      }, 500); // Wait for list refresh
                    }
                  },
                ),
              );
            } else if (process.env.REACT_APP_ENV === "clinic") {
              console.log("props: ", process.env.REACT_APP_ENV);
              setPaymentModal(true);
            } else {
              props.history.push({
                pathname: `/Payment/${name}/${patientId}/${visitId}/${erpCustId}`,
              });
            }
          }
        }, 3000);
      } else {
        setMessageDetails({
          message: event.successMessages[0],
          error: "error",
        });
      }
    }
  };

  const listFloors = (data) => {
    dispatch(
      patientActions.listFloors((resCb) => {
        if (resCb) {
          console.log("listFloors Response:", resCb);
          setPatientList(resCb);
        }
      }),
    );
  };
  const [search, setSearch] = useState({
    patient: "",
  });
  const [showDate, setShowDate] = useState("");
  const handleInputChange = (name, value) => {
    const ALLOWED_ROLES = [
      ROLE_KEYS.Doctor,
      ROLE_KEYS.Director,
      ROLE_KEYS.Nurse,
    ];
    const updatedSearch = { ...search, [name]: value };
    setSearch(updatedSearch);
    const inputText = (updatedSearch.patient || "").trim();

    if (inputText.length === 0) {
      let role = JSON.parse(localStorage.getItem("role"));
      if (ALLOWED_ROLES.includes(role)) {
        setHideResults(false);
        setShowDate("");
        debouncelistPatients(); // fallback
      } else {
        setIsMedicalOffice(true);
        renderVisitLists();
      }

      return;
    }
    if (inputText.length > 2 && showDate === "") {
      setHideResults(false);

      if (patientList.length > 0) {
        const text = inputText.toLowerCase();

        const filteredList = patientList.filter(
          (patient) =>
            patient.fname?.toLowerCase().includes(text) ||
            patient.mname?.toLowerCase().includes(text) ||
            patient.lname?.toLowerCase().includes(text) ||
            patient.id?.toString().includes(text),
        );

        setPatientList(filteredList);
        setSortPatientList(filteredList);
        setCounts(filteredList);
      }
      return;
    }
    if (showDate !== "") {
      debounceSearchPatientResult(inputText);
      return;
    }
    setHideResults(true);
  };

  const debouncelistPatients = useCallback(
    debounce((data) => loadPatientListByRole(data), 600),
    [],
  );

  const searchPatientResult = (data) => {
    console.log("data", data, showDate);
    let searchQuery = {};
    if (data && data.dateFrom && data.dateFrom != "") {
      searchQuery = { ...data };
      console.log("data: 485", searchQuery);
    } else {
      searchQuery = {
        bodyParams: {
          searchString: data,
          flag: "",
        },
      };
    }
    var ServerResVal = ServerRes;
    let id = null;
    if (
      !(
        sessionStorage.getItem("visitDetailsBy") &&
        sessionStorage.getItem("visitDetailsBy") !== null
      )
    ) {
      id = Number(localStorage.getItem("id"));
      console.log("id", id);
    } else if (
      sessionStorage.getItem("visitDetailsBy") &&
      sessionStorage.getItem("visitDetailsBy") !== null
    ) {
      let det = JSON.parse(sessionStorage.getItem("visitDetailsBy"));
      id = det.targetId;
    }
    console.log("dataset", dataset);
    let targetId = id != null ? id : dataset?.targetId;
    dispatch(
      patientActions.patientSearch(searchQuery, (resCb) => {
        if (resCb) {
          if (resCb?.state == "success" && hideResults == false) {
            console.log(
              "patient search resCb name in patient list : ",
              resCb,
              dataset,
              targetId,
              id,
            );

            // messageStrip

            let patientCollection = [];
            if (resCb.state == "success") {
              let patientInfo = resCb;
              if (resCb.patientListCollection) {
                // setMessageDetails({message:''});
                for (let pat of resCb.patientListCollection) {
                  if (pat.visitAssignmentList) {
                    for (let patVisit of pat.visitAssignmentList) {
                      if (targetId && targetId == patVisit.targetid) {
                        const patientExists = patientCollection.some(
                          (p) => p.id === pat.id,
                        );
                        if (!patientExists) {
                          patientCollection.push(pat);
                        }
                      }
                    }
                  }
                }
                console.log("pataientcollection", patientCollection);
                for (let pat of resCb.patientListCollection) {
                  pat["join"] = timecheck(
                    pat.visit.apptdate,
                    pat.visit.appthours,
                    pat.visit.apptminutes,
                  );
                  pat.fullName = [pat.fname, pat.mname, pat.lname]
                    .filter(Boolean)
                    .join(" ");
                  //   console.log("patient full name in patient list : ",pat )
                }
                setCounts(patientCollection);
                if (patientCollection.length !== 0) {
                  setPatientList(patientCollection);
                  setSortPatientList(patientCollection);
                  setCounts(patientCollection);
                } else if (isLabAdmin === true) {
                  setPatientList(resCb.patientListCollection);
                  setSortPatientList(resCb.patientListCollection);
                  setCounts(resCb.patientListCollection);
                } else if (isMedicalOffice === true) {
                  setPatientList(resCb.patientListCollection);
                  setSortPatientList(resCb.patientListCollection);
                  setCounts(resCb.patientListCollection);
                } else if (isRadiology === true) {
                  setPatientList(resCb.patientListCollection);
                  setSortPatientList(resCb.patientListCollection);
                  setCounts(resCb.patientListCollection);
                } else if (isxRay === true) {
                  setPatientList(resCb.patientListCollection);
                  setSortPatientList(resCb.patientListCollection);
                  setCounts(resCb.patientListCollection);
                } else if (targetId == 0) {
                  setPatientList(resCb.patientListCollection);
                  setSortPatientList(resCb.patientListCollection);
                  setCounts(resCb.patientListCollection);
                }
                console.log("Patientlist fullname update 2:", patientList);
                // },200)
                setDoctorList();
                // setCounts(patientCollection);
              }

              console.log("response from api : ", resCb);
            }
          }
        }
      }),
    );
  };

  const debounceSearchPatientResult = useCallback(
    debounce((payload) => searchPatientResult(payload), 500),
    [],
  );

  const listPatients = (data) => {
    let role = JSON.parse(localStorage.getItem("role"));
    console.log("listpatients data", data, role);
    setSortPatientList([]);
    // console.log("doctorDuty, data.targetId",doctorDuty )
    let targetId;
    if (data) {
      targetId = data.targetId;
      if (targetId != "") {
        console.log("doctorDuty, targetid, in if ", doctorDuty, targetId);
        setDoctorDuty(true);
      } else {
        console.log("doctorDuty, data.targetId, in else", doctorDuty, targetId);
        setDoctorDuty(false);
      }
    }
    console.log("doctorDuty, data.targetId", doctorDuty, targetId);

    if (!data) return;
    if (!isLabAdmin || !isMedicalOffice || !isRadiology || !isxRay) {
      dispatch(
        patientActions.ListPatients(data, (resCb) => {
          let allPatientsList;
          if (resCb) {
            console.log("Diagnosis Master API Response:", resCb);
            if (resCb) {
              var doctorId = {};
              if (resCb.personList) {
                console.log("resCb.personlist", resCb.patient);
                //            doctorId.gvId = resCb.personList[0].gvId;
                if (
                  resCb &&
                  resCb.personList &&
                  resCb.personList != undefined &&
                  resCb.personList.length != 0
                ) {
                  doctorId.id = resCb.personList[0].personId;
                  setDoctorInfo(doctorId);
                }
              }

              for (let pat of resCb.patient) {
                console.log("patient listPatients pat FOR LOOP 332: ", pat);
                pat["join"] = timecheck(
                  pat.visit.apptdate,
                  pat.visit.appthours,
                  pat.visit.apptminutes,
                );
                pat.fullName = [pat.fname, pat.mname, pat.lname]
                  .filter(Boolean)
                  .join(" ");

                if (pat.person && pat.person.first_name) {
                  console.log("fullName of doctor : ", pat.person);
                  const str = pat.person.first_name;
                  // const str2 = str.charAt(0).toUpperCase() + str.slice(1);
                  pat.person["fullName"] =
                    pat.person.displaytitle + " " + pat.person.first_name;
                }
                console.log("patient listPatients pat FOR LOOP 356: ", pat);

                //sort patientlist by meeting join time and then by visitdate
                const trueOnly = resCb.patient.filter((resCb) => resCb.join);
                const falseOnly = resCb.patient.filter(
                  (resCb) => resCb.join == false,
                );
                for (let eachItem of falseOnly) {
                  pat["visitDate"] = eachItem.visit.visitDate;
                }
                falseOnly.sort(function (x, y) {
                  return new Date(y.visitDate) - new Date(x.visitDate);
                });
                allPatientsList = trueOnly.concat(falseOnly);
                console.log("allSortedPatient", allPatientsList);
              }
            }
          }
          let target = "";
          console.log("Role name:", NURSE_ROLE, FLOORNURSE);

          if (role == NURSE_ROLE || role == FLOORNURSE) {
            if (data.targetId !== null && data.targetId !== "") {
              console.log("listpatients data", data);

              target = data.selectedOption;
              if (target == "All Patient") {
                console.log("target", target);
                let result = target.trim();
                console.log("result", result);
                setOptions(result);
              } else if (
                typeof target === "string" &&
                target.trim() !== "" &&
                target.includes(",")
              ) {
                let options = target.split(",");
                // Extract the first option and trim whitespaces
                let result = options[0].trim();
                console.log(result);
                setOptions(result);
              }
            } else if (data.floorId !== null && data.floorId !== "") {
              target = " Floor " + data.selectedOption;
              setOptions(target);
            } else if (data.department !== null && data.department !== "") {
              target = data.selectedOption + " department ";
              setOptions(target);
            }

            if (allPatientsList == null || allPatientsList == undefined) {
              var ServerResVal = ServerRes;
              let result = "";
              console.log("There are no patients in ", target);
              console.log("There name", target);
              if (data.targetId !== null) {
                if (
                  typeof target === "string" &&
                  target.trim() !== "" &&
                  target.includes(",")
                ) {
                  let options = target.split(",");
                  // Extract the first option and trim whitespaces
                  result = options[0].trim();
                  target = result;
                }
              }
              setOptions(target);
              ServerResVal.error = "There are no patients in " + target;
              setServerRes({ ...ServerResVal });
              setTimeout(() => {
                closeAlert();
                props.history.push("/patient");
              }, 5000);
            }
          }
          setCounts(allPatientsList);
          setSortPatientList(allPatientsList);
          setPatientList(allPatientsList);

          //}
        }),
      );
    }
  };

  const setCounts = (list) => {
    if (list === undefined) {
      console.log(" LIST IS UNDEFINED ");
      setIPcount(0);
      setOPcount(0);
      setWalkinCount(0);
      setAllcount(0);

      return;
    }
    if (list.length === 0) {
      console.log(" LIST IS EMPTY ");
      setIPcount(0);
      setOPcount(0);
      setWalkinCount(0);
      setAllcount(0);

      return;
    }
    if (list && list.length > 0) {
      let IP = list.filter(
        (item) =>
          item.visit.type == "InPatient" &&
          (item.visit.visitflag || "").toLowerCase() !== "walkin",
      ).length;
      setIPcount(IP);
      let OP = list.filter((item) => item.visit.type == "OutPatient").length;
      setOPcount(OP);
      let walkin = list.filter(
        (item) => (item.visit.visitflag || "").toLowerCase() === "walkin",
      ).length;
      setWalkinCount(walkin);

      setAllcount(list.length);
    }
  };
  const showjoinnow = () => {
    setjoinnow(true);
  };

  const showPatientDetails = (info) => {
    //not in use
    console.log("event : ...", info);
    //setShowPatientBasic(true)
    //setShowPatientProcedure(false)
    let patientId = info.id;
    dispatch(
      patientActions.getPatientProfile(patientId, (resCb) => {
        if (resCb) {
          console.log("Diagnosis Master API Response:", resCb);
          dispatch(patientActions.setPatientDetails(resCb));
          return resCb;
          //patientprofile api call
          // setSelectedPatientInfo(resCb)
        }
      }),
    );
  };

  //ERP CHANGES - PRATHIBHA
  const closeRevisitModal = (event) => {
    console.log("event:", event);
    setshowPatientRevisitModal(false);
    var ServerResVal = event;
    if (event && event.successMessages) {
      ServerResVal.success = event.successMessages[0];
    }
    if (event && event.errorMessages) {
      ServerResVal.error = event.errorMessages[0];
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
      loadPatientListByRole();
      setSelectedPatient();
    }, 3000);
  };
  //

  const openPatientBasic = (event) => {
    console.log("event : ", event);
    console.log("called basic", showPatientBasic);
    let modals = document.getElementsByClassName("expanded-views");
    let schemaFormBtn = document.getElementsByClassName("rjsf")[0];
    setShowPatientEditForm(true);

    if (modals) {
      for (let i = 0; i <= modals.length; i++) {
        console.log("modals:", modals[i]);
        if (modals[i])
          !showPatientBasic
            ? modals[i].classList.add("adjust-width")
            : modals[i].classList.remove("adjust-width");
      }
      if (schemaFormBtn) {
        !showPatientBasic
          ? schemaFormBtn.lastChild.childNodes[0].classList.add("adjust-width")
          : schemaFormBtn.lastChild.childNodes[0].classList.remove(
              "adjust-width",
            );
      }
      // !showPatientBasic ? el.classList.add('adjust-width'):el.classList.remove('adjust-width');
    }
    setRenderPrescription(!renderPrescription);
    console.log("called basic", showPatientBasic);
    if (event && event.lastvisited) {
      console.log("if event");

      setSelectedDatePres(event.lastvisited);
    } else {
      // setShowPatientBasic(!showPatientBasic)
      console.log("else event");
      setSelectedDatePres("");
      // if(!showPatientBasic){
      let patient = {};
      patient["id"] = selectedPatient.id;
      dispatch(
        patientActions.getPatientProfile(selectedPatient.id, (resCb) => {
          if (resCb) {
            // console.log("getPatientInfo resp age phno and last visited:",resCb)          .
            //  setSelectedPatientInfo(resCb);
            console.log("selected info:", resCb);
            setShowPatientBasic(!showPatientBasic);
            dispatch(patientActions.setPatientDetails(resCb));
          }
        }),
      );
      // dispatch(patientActions.getPatientLasteVisited(selectedPatient.id,resCb=>{
      //   if(resCb){
      //     console.log("Diagnosis Master API Response:",resCb)
      //    setSelectedPatientInfo(resCb)
      //     }
      // }))
      return selectedPatientInfo;
      // }
    }
  };

  const reviewNotes = (data) => {
    // let data = {}

    dispatch(
      doctorActions.reviewNotes(data, (resCb) => {
        if (resCb) {
          console.log("reviewZoomNotes API Response:", resCb);
          // setSelectedPatientInfo(resCb)
        }
      }),
    );
    setTimeout(() => {
      setShowReviewModel(true);
    }, 500);
  };

  const zoomReviewModal = () => {
    setShowReviewModel(false);
  };

  // Add this function after the closeAppointmentModal function or with other close handlers
  const closeAppointmentModal = (event) => {
    console.log("Appointment modal closed:", event);
    setShowAppointmentModal(false);
    setNewPatientForAppointment(null);

    // **Handle successful appointment scheduling**
    if (event && event.successMessages) {
      console.log("Appointment scheduled successfully:", event);

      // Refresh the patient list to show updated doctor assignment
      renderVisitLists();

      // Show success message
      setMessageDetails({
        message: "Patient onboarded and doctor assigned successfully",
        success: "success",
      });

      setTimeout(() => {
        setMessageDetails({ message: "", success: "" });
      }, 3000);
    } else if (event && event.errorMessages) {
      // Handle error case
      setMessageDetails({
        message: event.errorMessages[0] || "Failed to assign doctor",
        error: "error",
      });

      setTimeout(() => {
        setMessageDetails({ message: "", error: "" });
      }, 3000);
    }
  };

  const joinMeeting = (patient) => {
    console.log("joinMeeting ", patient);
    let patientId = patient.id;
    let visitId = patient.visit.id;
    let meetingId = patient.visit.mid;
    let groupId = "";
    let visit = "";
    let name = patient.fname + " " + (patient.lname ? patient.lname : "");
    let meetingInfo = {};
    meetingInfo["patientId"] = patientId;
    meetingInfo["visitId"] = visitId;
    meetingInfo["meetingId"] = meetingId;
    //get visit meeting groupid if present
    // visit
    if (patient.visit) {
      dispatch(
        patientActions.getVisitbyId(patient.visit, (resCb) => {
          if (resCb) {
            if (resCb.visit && resCb.visit.groupId) {
              visit = resCb.visit;
              groupId = resCb.visit.groupId;
            }
            console.log("reviewZoomNotes API Response:", resCb);
            // setSelectedPatientInfo(resCb)
          }
        }),
      );
    }
    if (!groupId || groupId != "") {
      groupId = Date.now() + "_" + patientId + "_" + visitId;
      meetingInfo["groupId"] = groupId;
      if (visit && !visit.groupId) visit["groupId"] = groupId;
    } else {
      visit.groupId = groupId;
      dispatch(
        patientActions.updateGroupId(visit, (resCb) => {
          if (resCb) {
            if (resCb.visit && resCb.visit.groupId) {
              groupId = resCb.visit.groupId;
            }
            console.log("reviewZoomNotes API Response:", resCb);
            // setSelectedPatientInfo(resCb)
          }
        }),
      );
    }

    console.log(
      "patientId and visitId",
      meetingId + "/" + patientId + "/" + visitId + "/" + groupId,
    );

    let url =
      "/ZoomMeeting/" +
      name +
      "/" +
      meetingId +
      "/" +
      patientId +
      "/" +
      visitId +
      "/" +
      groupId;
    window.open(url);
  };

  const getFormattedDate = (date) => {
    const reqdate = new Date(date);
    // const formatteddate = day + "/" + month + "/" + year + "   " +  hour+ ":" + min;
    let formatteddate = format(reqdate, "MMM dd yyyy' 'HH:mm");
    return formatteddate;
  };
  const getFormattedapptdate = (date) => {
    const apptdate = new Date(date);
    // const formatteddate = day + "/" + month + "/" + year + "   " +  hour+ ":" + min;
    let formattedapptdate = format(apptdate, "MMM dd yyyy");
    return formattedapptdate;
  };

  const meetingInfos = useSelector(
    (state) => state.zoomDetailsState.meetingInfo,
  );
  // const zoomMeetingReview = useSelector(state => state.doctorDetailsState.zoomReview)
  const patientProcedureInfo = useSelector(
    (state) => state.patientDetailsState.patientInfo,
  );
  const floorsList = useSelector(
    (state) => state.patientDetailsState.floorsList,
  );

  const closePatientFormModal = () => {
    setOpenAddPatientModal(false);
    setAddNewPatient(false);
  };

  //ERP CHANGES -Prathibha
  const closePaymentModal = (e, status) => {
    console.log("closePaymentModal called", e);
    if (status === "Completed") {
      setPaymentModal(false);
      // onboardPatient(e);
      assignDoctorForPatient(e);
    } else {
      setPaymentModal(false);
    }
  };

  const addPatient = (details, isAddNew) => {
    // props.history.push({
    //   pathname: `/patient/new`,
    // });

    if (isLabAdmin === true) {
      // Navigate to PatientOneStepOnboard with state indicating source
      history.push({
        pathname: "/PatientOneStepOnboard",
        state: {
          returnTo: "DoctorHomeView", // Add this to indicate where to return
        },
      });
      return; // Exit the function early
    }
    console.log("detailsp: ", details);
    if (isAddNew === true) {
      console.log("isAddNew:", isAddNew);
      setAddNewPatient(true);
      setOpenAddPatientModal(true);
      setshowPatientDetail(true);
      // setPatientInfo(pateint);
      dispatch(patientActions.setPatientDetails(details));
    }
    console.log("Add new : ", isAddNew);
    console.log("pDetail : ", details);

    console.log("props:", props);
    if (document.getElementById("user-list"))
      document.getElementById("user-list").classList.add("mobile-view");
    if (document.getElementById("user-info"))
      document.getElementById("user-info").classList.add("mobile-view");
    let pateint = patientInfo;
    // setPatientInfo(pateint);
    // setShowPatientProcedure(false);
    // setShowPatientBasic(false);
    // setAddNewPatient(true);
  };

  const revisit = (patient) => {
    console.log("revisit patient:");
    onboardPatient(patient);
    loadPatientListByRole();
  };

  const onboardPatient = (data) => {
    var ServerResVal = ServerRes;
    let admissionDateTime = "";
    let type = "OutPatient";
    console.log("props: ", data);
    data.appointmentFlag = false;
    //PRATHIBHA
    dispatch(
      patientActions.onboardPatient(data, type, admissionDateTime, (resCb) => {
        if (resCb) {
          console.log("onboardPatient response", resCb);
          if (resCb.successMessages) {
            let visitId = resCb.patientresp.visit.id;
            let patientId = resCb.patientresp.id;
            ServerResVal.success = "Patient onboarded successfully";
            //PRATHIBHA
            assignDoctorForPatient(resCb);
            loadPatientListByRole();
          } else if (resCb.state === "error") {
            ServerResVal.error = "Patient onboard failed";
          }
          setServerRes({ ...ServerResVal });
          setTimeout(() => {
            closeAlert();
          }, 5000);
        }
      }),
    );
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const assignDoctorForPatient = (event) => {
    console.log("event called for assigndoctorfor patient:", event);
    console.log("patientInfo:", patientInfo);
    var ServerResVal = ServerRes;
    setServerRes({ ...ServerResVal });
    let docInfo = JSON.parse(localStorage.getItem("doctorInformation"));
    console.log("docInfo: ", docInfo);
    if (docInfo && docInfo != null) {
      var assigndoc = {};
      assigndoc["id"] = event.patientresp ? event.patientresp.id : event.id;
      assigndoc["visit"] = {};
      assigndoc.visit["id"] =
        event.patientresp && event.patientresp.visit
          ? event.patientresp.visit.id
          : event.visit.id;
      assigndoc.visit["apptdate"] = format(new Date(), "yyyy-MM-dd");
      // assigndoc.visit

      let person = {
        personId: docInfo.personId,
        first_name: docInfo.first_name,
        last_name: docInfo.last_name,
        department: docInfo.department,
        role: docInfo.role ? docInfo.role : "Doctor",
      };
      assigndoc["person"] = person;
      //call assign doctor api
      console.log("assign doc:", assigndoc);
      dispatch(
        doctorActions.assignDoctor(assigndoc, (resCb) => {
          if (resCb) {
            setAddNewPatient(false);
            loadPatientListByRole();
            if (
              document.getElementById("user-list") &&
              document
                .getElementById("user-list")
                .classList.contains("mobile-view")
            )
              document
                .getElementById("user-list")
                .classList.remove("mobile-view");
            console.log("Doctor Assigned Successfully:", resCb);
            if (resCb.successMessages) {
              ServerResVal.success = "Patient Added Successfully.";
            } else {
              ServerResVal.error = "Failed to add Patient!";
            }
            setTimeout(() => {
              closeAlert();
            }, 3000);
          }
        }),
      );
    }
  };
  const closeCalendarModal = (event) => {
    setCalenderModal(false);
  };

  const showCalenderModal = () => {
    setCalenderModal(true);
  };
  const handleToggleLogout = () => {
    setLogoutVisible(!logoutVisible);
  };

  const handleChange = (value) => {
    setDate(value);
    setShowCalendar(false);
    setShowDate(format(value, "yyyy-MM-dd"));
    console.log("typeof(value)", typeof value);
    let data = {};
    if (selectedOpt == "Visit Date") {
      data = {
        dateFrom: format(value, "yyyy-MM-dd"),
        dateTo: "",
        bodyParams: {
          searchString: "",
          flag: "VisitDate",
        },
      };
    } else if (selectedOpt == "Followup Date") {
      data = {
        dateFrom: format(value, "yyyy-MM-dd"),
        dateTo: "",
        bodyParams: {
          searchString: "",
          flag: "FollowupDate",
        },
      };
    }
    console.log("handleChange: ", data);

    setSortPatientList([]);
    setIPcount(0);
    setOPcount(0);
    setWalkinCount(0);
    setAllcount(0);
    setHideResults(false);
    debounceSearchPatientResult(data);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const toggleFilterOptions = () => {
    setShowFilterOption(!showFilterOption);
    // handleallVisitdates();
  };
  const handleSelectChange = (event) => {
    console.log("handleSelectChange", event.target.textContent, event);
    setSelectedOpt(event.target.textContent);
    setShowCalendar(!showCalendar);
    setShowFilterOption(!showFilterOption);
    setShowPatientProcedure(!showPatientProcedure);
    setAddNewPatient(true);
  };

  useEffect(() => {
    console.log(
      "Doctor Info in localStorage:",
      localStorage.getItem("doctorInformation"),
    );
  }, []);

  const openPasswordModal = () => {
    setLogoutVisible(false);
    setShowPasswordModal(true);
  };

  const closePasswordModal = () => {
    setShowPasswordModal(false);
    setPasswordData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  const handlePasswordChange = () => {};

  const handlePasswordSubmit = () => {};

  const openChangePassword = () => {
    setNewPassword("");
    setConfirmPassword("");
    setPwdError("");
    setPwdSuccess("");
    setOpenPwdPopup(true);
  };

  const closeChangePassword = () => {
    setOpenPwdPopup(false);
  };

  const saveDoctorPassword = () => {
    if (!newPassword || !confirmPassword) {
      setPwdError("Password cannot be empty");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPwdError("Passwords do not match");
      return;
    }

    //  Get logged-in doctor info from localStorage
    const doctorInfo = JSON.parse(
      localStorage.getItem("staffInformation") ||
        localStorage.getItem("doctorInformation"),
    );

    console.log("doctorInfo from localStorage:", doctorInfo);

    if (!doctorInfo) {
      setPwdError("Doctor information not found. Please login again.");
      return;
    }

    //  FIX: Create payload and explicitly set the new password
    const payload = {
      ...doctorInfo,
      password: newPassword, // Override with NEW password
    };

    //  CRITICAL: Convert dob to Date object if it exists and is a string
    if (payload.dob && typeof payload.dob === "string") {
      payload.dob = new Date(payload.dob);
    }

    //  Ensure required fields are present
    if (!payload.personId) {
      payload.personId =
        doctorInfo.personId || Number(localStorage.getItem("id"));
    }

    console.log("Payload being sent:", payload);

    dispatch(
      doctorActions.modifyDoctor(payload, (resCb) => {
        console.log("API Response:", resCb);

        if (resCb?.accresp?.success) {
          setPwdSuccess("Password changed successfully");

          //  Update localStorage with new doctor info
          const updatedDoctorInfo = { ...doctorInfo, password: newPassword };
          localStorage.setItem(
            "doctorInformation",
            JSON.stringify(updatedDoctorInfo),
          );

          setTimeout(() => {
            closeChangePassword();
          }, 1500);
        } else {
          setPwdError(resCb?.accresp?.error || "Unable to change password");
        }
      }),
    );
  };

  return (
    <main className="h-100" id="maincontainer_1">
      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      <div noGutters className="h-100 d-flex main-container ">
        {/* <PageTitle title="Patient Information" 
                    className="text-sm-left mb-3" /> */}
        <div className="list-left-menu h-100" id="user-list">
          <div className="main-content-container container-fluid h-100 position-relative p-0">
            <div className="row h-100 m-0">
              <div className="mb-12 col-sm-12 col-md-12 hpcol bg menu-head h-100 d-flex flex-column px-0">
                <div className="d-flex cpointer p-2 menu-content ">
                  <div
                    style={{ display: `flex` }}
                    className=" align-items-center"
                  >
                    <div className="blog-comments__content menu-head-content">
                      <div className="blog-comments__meta text-mutes">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* {helperServices.getLoggedUserName()} */}
                          <img
                            src="patient1.png"
                            className="img-disp"
                            style={{ width: `40px`, height: `40px` }}
                          ></img>
                          {role === NURSE_ROLE ? (
                            <span className="px-2 doctor-home-doct-name">
                              {userName}{" "}
                              <small className="text-muted">
                                {" "}
                                <br /> {options}
                              </small>
                            </span>
                          ) : (
                            <span className="px-2 doctor-home-doct-name">
                              {userName}
                              <small className="text-muted">
                                {" "}
                                <br /> {qualification}
                              </small>
                            </span>
                          )}

                          {role === DOCTOR_ROLE ||
                          role === DIRECTOR_ROLE ||
                          role === LAB_ADMIN ? (
                            <span
                              title="Report"
                              style={{ paddingLeft: "11rem" }}
                              onClick={() => history.push("/MyReports")}
                            >
                              <svg
                                width="15"
                                height="15"
                                xmlns="http://www.w3.org/2000/svg"
                                shape-rendering="geometricPrecision"
                                text-rendering="geometricPrecision"
                                image-rendering="optimizeQuality"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                viewBox="0 0 458 512.36"
                              >
                                <g fill="#000000">
                                  <path d="M258.16 479.77v20.92H27.6C12.56 500.69 0 488.16 0 473.1V27.6C0 12.5 12.5 0 27.6 0h356.09c15.04 0 27.6 12.53 27.6 27.6v250.56h-20.94v-84.63H22.24l-.92-.04v282.78c0 2.12 1.77 3.88 3.89 3.88l232.95-.38zm-8.8-41.72v12.54c0 .68-.45 1.13-1.11 1.13H50.79c-.67 0-1.12-.45-1.12-1.13v-12.54c0-.67.45-1.12 1.12-1.12h197.46c.67 0 1.11.45 1.11 1.12zm-19.04-36.89v12.53c0 .69-.45 1.14-1.12 1.14H50.79c-.67 0-1.12-.45-1.12-1.14v-12.53c0-.68.45-1.13 1.12-1.13H229.2c.68 0 1.12.46 1.12 1.13zm-19.04-36.9v12.54c0 .68-.45 1.13-1.11 1.13H50.79c-.67 0-1.12-.45-1.12-1.13v-12.54c0-.68.45-1.12 1.12-1.12h159.38c.67 0 1.11.45 1.11 1.12zm104.4-55.18h130.43c6.53 0 11.89 5.32 11.89 11.85v179.54c0 6.53-5.36 11.89-11.89 11.89H315.68c-6.53 0-11.89-5.33-11.89-11.86V320.97c0-6.53 5.36-11.89 11.89-11.89zm102.9 34.64h3.82v20.6h-3.82v-20.6zm-86.77 48.4h18.72c1.61 0 2.93 1.33 2.93 2.93v16.42a2.94 2.94 0 0 1-2.93 2.93h-18.72c-1.6 0-2.92-1.32-2.92-2.93v-16.42c0-1.6 1.32-2.93 2.92-2.93zm0 76.4h18.72c1.61 0 2.93 1.33 2.93 2.92v16.44c0 1.6-1.32 2.92-2.93 2.92h-18.72c-1.6 0-2.92-1.32-2.92-2.92v-16.44c0-1.59 1.32-2.92 2.92-2.92zm0-38.2h18.72c1.61 0 2.93 1.33 2.93 2.93v16.43c0 1.6-1.32 2.92-2.93 2.92h-18.72c-1.6 0-2.92-1.32-2.92-2.92v-16.43c0-1.6 1.32-2.93 2.92-2.93zm79.47-38.2h18.73c1.6 0 2.89 1.33 2.89 2.93v16.42c0 1.61-1.32 2.93-2.89 2.93h-18.73c-1.6 0-2.92-1.32-2.92-2.93v-16.42c0-1.6 1.29-2.93 2.92-2.93zm0 76.4h18.73c1.6 0 2.89 1.33 2.89 2.92v16.44c0 1.6-1.32 2.92-2.89 2.92h-18.73c-1.6 0-2.92-1.32-2.92-2.92v-16.44c0-1.59 1.29-2.92 2.92-2.92zm0-38.2h18.73c1.6 0 2.89 1.33 2.89 2.93v16.43c0 1.6-1.32 2.92-2.89 2.92h-18.73c-1.6 0-2.92-1.32-2.92-2.92v-16.43c0-1.6 1.29-2.93 2.92-2.93zm-39.75-38.2h18.72c1.61 0 2.93 1.33 2.93 2.93v16.42a2.94 2.94 0 0 1-2.93 2.93h-18.72c-1.6 0-2.92-1.32-2.92-2.93v-16.42c0-1.6 1.32-2.93 2.92-2.93zm0 76.4h18.72c1.61 0 2.93 1.33 2.93 2.92v16.44c0 1.6-1.32 2.92-2.93 2.92h-18.72c-1.6 0-2.92-1.32-2.92-2.92v-16.44c0-1.59 1.32-2.92 2.92-2.92zm0-38.2h18.72c1.61 0 2.93 1.33 2.93 2.93v16.43c0 1.6-1.32 2.92-2.93 2.92h-18.72c-1.6 0-2.92-1.32-2.92-2.92v-16.43c0-1.6 1.32-2.93 2.92-2.93zm-42.18-98.82h103.09c3.2 0 5.85 2.65 5.85 5.85v33.32c0 3.2-2.65 5.85-5.85 5.85H329.35c-3.2 0-5.85-2.66-5.85-5.85v-33.32c0-3.2 2.65-5.85 5.85-5.85zm102.32 6.62H330.12v31.78h101.55v-31.78zm14.44-20.72H315.68c-1.98 0-3.61 1.58-3.61 3.57V500.5c0 1.97 1.6 3.57 3.58 3.57h130.43c1.97 0 3.57-1.6 3.57-3.57V320.97c0-1.96-1.57-3.57-3.54-3.57zm-108.69-81.46v12.41c0 .68-.44 1.12-1.1 1.12H207.44c-.67 0-1.11-.44-1.11-1.12v-12.41c0-.68.44-1.12 1.11-1.12h128.88c.66 0 1.1.44 1.1 1.12zm-58.3 34.94v12.43c0 .66-.44 1.1-1.12 1.1h-70.33c-.67 0-1.12-.44-1.12-1.1v-12.43c0-.67.45-1.11 1.12-1.11H278c.45 0 1.12.44 1.12 1.11zm-165.5 9.27 43.3.78c0 16-7.64 30.69-20.38 39.61l-22.92-40.39zm-2.9-65.6v-3.41l3.32.27c4.07.25 8.14 1.04 11.97 2.1 3.82 1.04 7.39 2.62 10.95 4.45 20.88 11.23 29.36 30.05 31.08 53.25l-56.96-1.57-.36-55.09zm6.63 48.8 44.07 1.31c-1.79-17.84-12.49-33.31-27.27-41.45-4.63-2.39-9.57-4.14-14.67-5.12-.88-.17-1.75-.3-2.64-.39l.51 45.65zm6.45 56.23c-7.64 4.45-16.05 6.83-24.71 6.83-27.26 0-49.42-22.83-49.42-50.92 0-27.28 20.89-49.84 47.38-50.89l2.04 50.89 24.71 44.09zm266.55-145.94V25.2c0-2.11-1.75-3.89-3.87-3.89H25.21c-2.2 0-3.89 1.72-3.89 3.89v148.48l.92-.04h368.11zM133.2 63.39H158c.94 0 1.56.62 1.56 1.56v86.59c0 .94-.62 1.56-1.56 1.56h-24.8c-.94 0-1.56-.62-1.56-1.56V64.95c0-.94.62-1.56 1.56-1.56zm62.85 32.91h24.8c.94 0 1.56.62 1.56 1.56v53.37c0 .94-.62 1.56-1.56 1.56h-24.8c-.94 0-1.56-.62-1.56-1.56V97.86c0-.62.62-1.56 1.56-1.56zm125.71 0h24.8c.94 0 1.56.62 1.56 1.56v53.37c0 .94-.62 1.56-1.56 1.56h-24.8c-.94 0-1.56-.62-1.56-1.56V97.86c0-.62.62-1.56 1.56-1.56zM258.9 63.39h24.79c.95 0 1.57.62 1.57 1.56v86.59c0 .94-.62 1.56-1.57 1.56H258.9c-.95 0-1.57-.62-1.57-1.56V64.95c0-.94.62-1.56 1.57-1.56zM70.35 75.29h24.79c.94 0 1.56.62 1.56 1.58v74.67c0 .94-.62 1.56-1.56 1.56H70.35c-.94 0-1.56-.62-1.56-1.56V76.87c-.32-.96.62-1.58 1.56-1.58z" />
                                </g>
                              </svg>
                            </span>
                          ) : (
                            ""
                          )}
                          {}
                          {doctorDuty ? (
                            <span
                              title="Calendar"
                              className="px-2"
                              onClick={() => showCalenderModal()}
                            >
                              <svg
                                width="15"
                                height="15"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                              >
                                <g fill="#808080">
                                  <path d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z" />
                                </g>
                              </svg>
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="blog-comments__content menu-head-icon">
                      <div className="blog-comments__meta text-mutes">
                        <div className="text-secondary pname">
                          <i
                            className="fas fa-ellipsis-v"
                            onClick={(event) => logoutOpt(event)}
                          ></i>
                          <div
                            // tag={Dropdown}
                            caret
                            toggle={toggleUserActions}
                          >
                            <div>
                              <Collapse
                                in={logoutVisible}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Menu
                                  id="medical_services"
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  open={logoutVisible}
                                  onClose={handleToggleLogout}
                                >
                                  {localStorage
                                    .getItem("AccessLevel")
                                    .includes("Assistant") && (
                                    <MenuItem
                                      onClick={(event) => selectVisit(event)}
                                    >
                                      <ListItemIcon>
                                        {/* Your icon for visit assignment details */}
                                        <i className="material-icons text-secondary">
                                          medical_services
                                        </i>
                                      </ListItemIcon>
                                      <ListItemText
                                        primary="Visit Assignment Details"
                                        className="text-secondary"
                                      />
                                    </MenuItem>
                                  )}

                                  <MenuItem onClick={openChangePassword}>
                                    <ListItemIcon>
                                      <i className="material-icons text-secondary">
                                        lock
                                      </i>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary="Change Password"
                                      className="text-secondary"
                                    />
                                  </MenuItem>
                                  <MenuItem
                                    component={Link}
                                    to="/"
                                    onClick={(event) => logout(event)}
                                  >
                                    <ListItemIcon>
                                      {/* Your icon for logout */}
                                      <i className="material-icons text-danger">
                                        &#xE879;
                                      </i>
                                    </ListItemIcon>
                                    <ListItemText
                                      primary="Logout"
                                      className="text-danger"
                                    />
                                  </MenuItem>
                                </Menu>
                              </Collapse>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-2 search-bar">
                  <form className="main-navbar__search w-100 d-md-flex d-lg-flex">
                    <div
                      className="input-group input-group-seamless"
                      style={{
                        flexWrap: "nowrap",
                        flexDirection: "row-reverse",
                      }}
                    >
                      <div className="input-group-prepend  mb-2">
                        <span className="input-group-text">
                          <i
                            style={{ color: `#111b21` }}
                            className="material-icons"
                          >
                            search
                          </i>
                        </span>
                      </div>

                      <div className="position-relative d-flex justify-content-between filter-container">
                        <div className="text-secondary pname">
                          <i
                            title="Filter"
                            className="material-icons m-2 filter-icon"
                            onClick={toggleFilterOptions}
                            style={{
                              marginRight: "0px !important",
                              marginTop: "4px !important",
                            }}
                          >
                            filter_list
                          </i>
                          <div>
                            <Collapse
                              in={showFilterOption}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Menu
                                id="medical_services"
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                open={showFilterOption}
                                onClose={toggleFilterOptions}
                              >
                                <MenuItem onClick={handleSelectChange}>
                                  <ListItemText
                                    primary="Visit Date"
                                    className="text-secondary"
                                  />
                                </MenuItem>
                                <MenuItem onClick={handleSelectChange}>
                                  <ListItemText
                                    primary="Followup Date"
                                    className="text-secondary"
                                  />
                                </MenuItem>
                              </Menu>
                            </Collapse>
                          </div>
                        </div>

                        {showCalendar && (
                          <div
                            className="position-absolute"
                            style={{ position: "absolute", zIndex: 1000 }}
                          >
                            <Calendar value={date} onChange={handleChange} />
                          </div>
                        )}
                      </div>
                      <TextField
                        className="navbar-search mb-2 menu-search"
                        placeholder="Search Patient..."
                        type="search"
                        fullWidth
                        value={showDate ? showDate : search.patient}
                        onChange={(event) =>
                          handleInputChange("patient", event.target.value)
                        }
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            const inputText = event.target.value?.trim();

                            if (inputText && inputText.length > 3) {
                              hideResults && setHideResults(false);
                              debounceSearchPatientResult(inputText);
                            }
                          }
                        }}
                        InputProps={{
                          style: {
                            paddingLeft: "12px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          },
                        }}
                      />
                    </div>
                  </form>
                </div>

                {countAll >= 0 && (
                  <div className="d-flex patinet-tab">
                    <span
                      className={
                        type === "InPatient" ? "type selectedtab" : "type"
                      }
                      onClick={(event) => changeTab("InPatient")}
                    >
                      In Patient&nbsp;<span>({countIP})</span>
                    </span>

                    <span
                      className={
                        type === "OutPatient" ? "type selectedtab" : "type"
                      }
                      onClick={(event) => changeTab("OutPatient")}
                    >
                      Out Patient&nbsp;<span>({countOP})</span>
                    </span>
                    <span
                      className={
                        type === "Walkin" ? "type selectedtab" : "type"
                      }
                      onClick={(event) => changeTab("Walkin")}
                    >
                      Walkin&nbsp;<span>({countWalkin})</span>
                    </span>
                    <span
                      className={type === "All" ? "type selectedtab" : "type"}
                      onClick={(event) => changeTab("All")}
                    >
                      All&nbsp;<span>({countAll})</span>
                    </span>
                  </div>
                )}

                <div className="blog-comments card pcard left-list-patient ">
                  {console.log("allPatientsList :", sortPatientList)}
                  {sortPatientList &&
                    sortPatientList.map((patient, index) => (
                      <div
                        className={
                          selectddiv == patient.id
                            ? "blog-comments__item d-flex p-2 cpointer flex-wrap highlight border-0"
                            : "blog-comments__item d-flex p-2 cpointer flex-wrap border-0"
                        }
                        key={index}
                      >
                        <div
                          className="blog-comments__content w-100 d-flex justify-content-between "
                          onClick={(event) =>
                            getPatientProcedureInfo(patient, index)
                          }
                        >
                          <div className="d-flex justify-content-between align-items-center patient-img">
                            <span>
                              {patient.imgurl ? (
                                <img
                                  src={patient.imgurl}
                                  className="img-disp mr-3"
                                  style={{ width: `40px`, height: `40px` }}
                                ></img>
                              ) : (
                                <img
                                  src="default.png"
                                  className="img-disp mr-3"
                                  style={{ width: `40px`, height: `40px` }}
                                ></img>
                              )}
                            </span>
                          </div>
                          <div className="patient-details pb-2 ml-2 d-flex justify-content-between align-items-center flex-column">
                            <div className="d-flex w-100 justify-content-between">
                              <div>
                                {patient.fullName}
                                {patient.age >= 0
                                  ? `(${patient.age}yrs)`
                                  : ""}{" "}
                                {patient.gender
                                  ? genderMap[patient.gender]
                                  : ""}
                                <br />
                                <small className="text-muted">
                                  MAIN-{patient.id}
                                </small>
                              </div>
                              {/* <div>{patient.fullName}</div> */}
                              <small className="date">
                                {patient.visit &&
                                  patient.visit.apptdate &&
                                  getFormattedapptdate(patient.visit.apptdate)}
                                {patient.visit &&
                                  patient.visit.appthours !== 0 && (
                                    <span>
                                      {" "}
                                      {patient.visit.appthours}:
                                      {patient.visit.apptminutes}
                                    </span>
                                  )}
                              </small>
                            </div>
                            {Array.isArray(patient?.roomList) &&
                              patient.roomList.length > 0 && (
                                <div className="d-flex flex-column w-100">
                                  <small className="text-muted">
                                    {patient.roomList
                                      .map((room) => {
                                        const floorId = room?.floorId;
                                        const roomName = room?.roomName?.trim();

                                        if (!roomName) return null;

                                        return floorId
                                          ? `floor ${floorId} - ${roomName}`
                                          : roomName;
                                      })
                                      .filter(Boolean)
                                      .join(", ")}
                                  </small>
                                </div>
                              )}

                            <div className="d-flex w-100 justify-content-between align-items-baseline">
                              <small className="text-muted">
                                {(role != DOCTOR_ROLE ||
                                  role != DIRECTOR_ROLE) &&
                                  patient.person &&
                                  patient.person.fullName &&
                                  patient.person.fullName}
                              </small>
                              {patient.visit &&
                                patient.visit.status == "close" && (
                                  <div className="w-100 d-flex justify-content-between align-items-center">
                                    <div>
                                      <small className="w-100">
                                        Last Visit:{" "}
                                        {getFormattedapptdate(
                                          patient.visit.visitDate,
                                        )}
                                      </small>
                                    </div>
                                    
                                    {/*
                                    <div>
                                      <button
                                        id="we"
                                        className="btn btn-submit btn-primary btn-style bottomright"
                                        onClick={(event) => revisit(patient)}
                                      >
                                        Re Visit
                                      </button>
                                    </div>
                                  
                                    */ 

                                    }
                                    
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {/* Prathibha - Redicare clinic version */}
                </div>

                {process.env.REACT_APP_ENV === "clinic" ? (
                  <div
                    className="add-patient"
                    onClick={(event) => addPatient("", true)}
                  >
                    <i className="material-icons" title="Add Patient">
                      add
                    </i>
                  </div>
                ) : (
                  ""
                )}

                {JSON.parse(localStorage.getItem("role")) === LAB_ADMIN ? (
                  <div
                    className="add-patient"
                    onClick={(event) => addPatient("", true)}
                  >
                    <i className="material-icons" title="Add Patient">
                      add
                    </i>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {calenderModal && (
          <div>
            {/* The Doctor Home calendar uses the leave-aware calendar so that
                unavailable periods and booking-plan sessions share one view.
                The former AppointmentScheduleModal call is intentionally kept
                below for reference and can be restored without losing props. */}
            {/* <Components.AppointmentScheduleModal
              doctorInfo={doctorInfo}
              type="Doctor"
              doctorHomeView={true}
              onModalClose={(event) => closeCalendarModal(event)}
            /> */}
            <DoctorLeaveCalender
              doctorInfo={doctorInfo}
              type="Doctor"
              doctorHomeView={true}
              onModalClose={(event) => closeCalendarModal(event)}
            />
          </div>
        )}

        {addNewPatient && (
          <div className="p-3 add-new flex-fill" style={{ overflowY: "auto" }}>
            <Components.PatientForm
              patientInfo={patientInfo}
              onSuccess={(event) => assignDoctorForPatient(event)}
              props={props}
            />
          </div>
        )}

        {!addNewPatient && (
          <div
            className={
              showPatientBasic
                ? "list-content-panel adjust-width mobile-view"
                : "list-content-panel mobile-view"
            }
            id="user-info"
          >
            <Components.LayoutHeader
              basic={showPatientBasic}
              lab_admin={isLabAdmin}
              radiology={isRadiology}
              medicalofficer={isMedicalOffice}
              x_ray={isxRay}
              selectedPatient={selectedPatient}
              onPatientBasic={(event) => openPatientBasic(event)}
              onVisitCompletion={(event) => onCloseVisitCompletion(event)}
            />

            {showPatientProcedure && !errorMessages ? (
              <>
                <Components.ProcedureListing
                  basic={showPatientBasic}
                  lab_admin={isLabAdmin}
                  medicalofficer={isMedicalOffice}
                  radiology={isRadiology}
                  x_ray={isxRay}
                  // selectedPatient = {selectedPatient}
                  showPatientEditForm={showPatientEditForm}
                  docList={doctorList}
                  onPatientBasic={(event) => openPatientBasic(event)}
                  selectedPatientInfo={selectedPatientInfo}
                />
              </>
            ) : (
              <ErrorScreen message={errorMessages} />
            )}
          </div>
        )}
        {showPatientBasic ? (
          <div className="patient-desc" style={{ backgroundColor: "#f5f6f8" }}>
            <>
              <Components.PatientEditForm
                selectedPatient={selectedPatient}
                onPatientBasic={(event) => openPatientBasic(event)}
              />
            </>
            {/* // </Col>  */}
          </div>
        ) : (
          ""
        )}

        {showVisits && (
          <Components.VisitsByType
            type="Doctor"
            close={(event) => closeModal(event)}
          />
        )}
        {paymentModal && (
          <Components.PaymentForClinic
            patientInfo={selectedPatientInfo}
            onModalClose={(event, status) => closePaymentModal(event, status)}
          />
        )}

        {showPatientRevisitModal ? (
          <Components.PatientRevisitModal
            patientData={selectedPatientInfo}
            patientRevisitDetails={revisitDetail}
            onModalClose={(event) => closeRevisitModal(event)}
          />
        ) : (
          ""
        )}
      </div>
      {addNewPatient && (
        <Components.PatientForm
          patientInfo={[]}
          openPatientForm={openAddPatientModal}
          closePatientForm={() => closePatientFormModal()}
          onSuccess={(event) => updatePatientDetails(event, "payment")}
        />
      )}

      {showAppointmentModal && newPatientForAppointment && (
        <Components.AppointmentScheduleModal
          patientData={newPatientForAppointment}
          type="Doctor"
          onModalClose={(event) => closeAppointmentModal(event)}
        />
      )}

      <Dialog open={openPwdPopup} onClose={closeChangePassword}>
        <div style={{ padding: 20, width: 350 }}>
          <h4>Change Password</h4>

          <TextField
            fullWidth
            type={showNewPassword ? "text" : "password"}
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            type={showConfirmPassword ? "text" : "password"}
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {pwdError && <Alert severity="error">{pwdError}</Alert>}
          {pwdSuccess && <Alert severity="success">{pwdSuccess}</Alert>}

          <div style={{ marginTop: 15, textAlign: "right" }}>
            <Button onClick={closeChangePassword}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={saveDoctorPassword}
              sx={{ ml: 1 }}
            >
              Save
            </Button>
          </div>
        </div>
      </Dialog>

      {/* </>
      )} */}
    </main>
  );
}
export default DoctorHomeView;
